import { useState, useEffect } from "react";
import config from "../config/config";
import { userSession } from "../observers/userObserver";

const useCurrency = () => {
  const [currency, setCurrency] = useState([]);

  useEffect(() => {
    console.log("useCurrency effect triggered");
    const fetchCurrency = async () => {
      try {
        const storedCurrencies = localStorage.getItem("currency");
        if (storedCurrencies) {
          setCurrency(JSON.parse(storedCurrencies)); // ✅ Use correct setter
          return;
        }
        const response = await fetch(`${config["backend-url"]}/all_currencies`, {
          method: 'GET', // Explicitly specify the method
          headers: {
            Authorization: `Bearer ${userSession.getToken()}`,
            'Content-Type': 'application/json'
          }
        });




       
        const data = await response.json();
        if (response.ok) {
          setCurrency(data);
          localStorage.setItem("currency", JSON.stringify(data));
        }
      } catch (error) {
        console.error("Error fetching currency:", error);
      }
    };

    fetchCurrency();
  }, []);

  return currency;
};

export default useCurrency;
